// Tombol kembali HP mengikuti asal alur, bukan entri riwayat mentah yang bisa berisi Checkout/Masuk.
// PR #42 perbaikan butir 4 (Haryanto 27/10/2026): asal menyimpan juga POSISI riwayatnya (`idx` dari react-router di history.state). Bila
// halaman asal tepat satu langkah di belakang → mundur sungguhan (nav(-1)): riwayat browser tidak berisi halaman ganda dan gesek kembali /
// tombol back browser sama dengan tombol kembali halaman. Selain itu (tautan langsung, asal tidak tepat di belakang) → replace ke asal.
const idxRiwayat = () => {
  const i = typeof window !== "undefined" ? window.history.state?.idx : undefined;
  return Number.isInteger(i) ? i : null;
};
export const asalNavigasiHp = (lokasi) => ({ hpKembali: {
  to: `${lokasi.pathname}${lokasi.search || ""}${lokasi.hash || ""}`,
  state: lokasi.state || null,
  idx: idxRiwayat(),
} });

const pathInternal = (to) => typeof to === "string" && to.startsWith("/") && !to.startsWith("//") && !to.includes("\\")
  ? to.split(/[?#]/)[0] : null;
const publik = (p) => p === "/" || p === "/syarat-ketentuan" || /^\/(katalog|produk|panduan)(\/|$)/.test(p || "");
const sesuai = (p, jenis) => {
  if (jenis === "checkout") return p === "/keranjang";
  if (jenis === "beli") return /^\/produk\//.test(p || "");
  if (jenis === "masuk") return publik(p);
  if (jenis === "produk") return publik(p) || p === "/keranjang";
  if (jenis === "pesanan") return p === "/pesanan";
  return publik(p) || p === "/akun" || /^\/pesanan(\/|$)/.test(p || "");
};

export function tujuanKembaliHp(lokasi, cadangan = "/katalog", jenis = "belanja") {
  const asal = lokasi.state?.hpKembali;
  const path = pathInternal(asal?.to);
  return path && path !== lokasi.pathname && sesuai(path, jenis) ? asal : { to: cadangan, state: null };
}

export function kembaliHp(nav, lokasi, cadangan, jenis) {
  const tujuan = tujuanKembaliHp(lokasi, cadangan, jenis);
  const kini = idxRiwayat();
  if (tujuan === lokasi.state?.hpKembali && Number.isInteger(tujuan.idx) && kini !== null && tujuan.idx === kini - 1) { nav(-1); return; }
  nav(tujuan.to, { replace: true, state: tujuan.state });
}

export function cadanganMasukHp(lokasi) {
  const from = lokasi.state?.from;
  if (publik(pathInternal(from))) return from;
  return /^\/(keranjang|checkout|akun|pesanan)(\/|$)/.test(pathInternal(from) || "") ? "/katalog" : "/";
}

export function opsiKeranjangHp(lokasi) {
  const asal = lokasi.state?.hpKembali;
  if (pathInternal(asal?.to) === "/keranjang") return { replace: true, state: asal.state || null };
  const belanja = tujuanKembaliHp(lokasi);
  return { replace: true, state: { hpKembali: belanja } };
}

// Masuk adalah langkah sementara: pulihkan asal belanja tanpa menyisipkan halaman Masuk ke alur kembali.
export function opsiSelesaiMasukHp(lokasi, tujuan) {
  const asal = lokasi.state?.hpKembali;
  if (!publik(pathInternal(asal?.to))) return { replace: true, state: null };
  return { replace: true, state: asal.to === tujuan ? asal.state || null : { hpKembali: asal } };
}
